module.exports = __webpack_public_path__ + "static/media/merchant_cash_voucher_app.5c00fb8d.jpg";